import request from "../utils/request";
// 获取小区
export function calorimeterStatisticalConsumptionData (data) {
    return request({
      method: 'get',
      url: 'calorimeterStatisticalConsumptionData',
      params: data
    })
  }